import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { PlaybackRateRange } from '../types/instance';

export const usePlaybackRateRange = () => {
    const instance = usePlayerInstance();
    const [playbackRateRange, setPlaybackRateRange] = useState<PlaybackRateRange | undefined>(
        () => instance?.playbackRateRange
    );

    useInstanceEffect((instance) => instance.onPlaybackRateRangeChange(setPlaybackRateRange));

    return playbackRateRange;
};
